import {
  connectAuthEmulator,
  connectFirestoreEmulator,
  connectFunctionsEmulator,
  getAnalytics,
  getAuth,
  getFirestore,
  getFunctions,
  getStorage,
  initializeApp,
} from 'shared/services/firebase';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_DATABASE_URL,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGE_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID,
  measurementId: import.meta.env.VITE_MEASUREMENT_ID,
};

export const initDB = () => {
  const app = initializeApp(firebaseConfig);
  let db = null;
  let auth = null;
  let functions = null;
  let analytics = null;
  let storage = null;

  if (import.meta.env.DEV) {
    db = getFirestore(app);
    auth = getAuth(app);
    functions = getFunctions(app);
    storage = getStorage();
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    connectAuthEmulator(auth, 'http://localhost:9099');
  }

  if (import.meta.env.PROD) {
    analytics = getAnalytics(app);
    db = getFirestore(app);
    auth = getAuth(app);
    functions = getFunctions(app);
    storage = getStorage(app);
  }

  return {
    app,
    db,
    analytics,
    auth,
    functions,
    storage,
  };
};
